"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Card = require("./Card.style");

var _Button = _interopRequireDefault(require("../../Button"));

var _TagList = _interopRequireDefault(require("../../TagList"));

var _AwardsList = _interopRequireWildcard(require("../../AwardsList/AwardsList"));

var _CardProfile = _interopRequireDefault(require("./CardProfile.style"));

var CardProfile = function CardProfile(_ref) {
  var profileImage = _ref.profileImage,
      coverImage = _ref.coverImage,
      name = _ref.name,
      jobTitle = _ref.jobTitle,
      awards = _ref.awards,
      location = _ref.location,
      skillTags = _ref.skillTags,
      featured = _ref.featured,
      primaryCta = _ref.primaryCta,
      secondaryCta = _ref.secondaryCta;

  var _ref2 = (0, _emotionTheming.useTheme)(),
      cards = _ref2.cards;

  return /*#__PURE__*/_react.default.createElement(_Card.ProfileWrapper, {
    image: profileImage
  }, /*#__PURE__*/_react.default.createElement(_Card.ProfileCardHeader, {
    coverImage: featured ? profileImage : coverImage
  }, featured && /*#__PURE__*/_react.default.createElement(_Card.ProfileImage, Object.assign({}, profileImage, {
    preserveStackingContext: true,
    mediaType: "backgroundImage"
  })), !featured && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Card.CardImage, Object.assign({}, coverImage, {
    preserveStackingContext: true,
    mediaType: "backgroundImage"
  })), /*#__PURE__*/_react.default.createElement(_Card.ProfileAvatar, {
    rectangular: true,
    image: profileImage,
    name: name
  }))), /*#__PURE__*/_react.default.createElement(_Card.ProfileCardContent, {
    image: profileImage
  }, /*#__PURE__*/_react.default.createElement(_Card.ContentBox, {
    featured: featured
  }, name && /*#__PURE__*/_react.default.createElement(_CardProfile.default, {
    size: featured ? cards.featuredCardLabelTextSize : cards.titleTextSize
  }, name), awards && awards.length > 0 && /*#__PURE__*/_react.default.createElement(_AwardsList.default, {
    awards: awards
  }), jobTitle && /*#__PURE__*/_react.default.createElement(_Card.SingleLineBody, {
    size: cards.copyTextSize
  }, jobTitle), location && /*#__PURE__*/_react.default.createElement(_Card.SingleLineBody, {
    size: cards.copyTextSize
  }, location), skillTags && skillTags.length > 0 && /*#__PURE__*/_react.default.createElement(_TagList.default, {
    tags: skillTags
  })), /*#__PURE__*/_react.default.createElement(_Card.CTAContainer, {
    justifyContent: "start",
    alignItems: "center"
  }, primaryCta && /*#__PURE__*/_react.default.createElement(_Button.default, primaryCta, primaryCta.label), secondaryCta && /*#__PURE__*/_react.default.createElement(_Button.default, secondaryCta, secondaryCta.label))));
};

CardProfile.propTypes = {
  /** Profile image - photo of the profile holder */
  profileImage: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }).isRequired,

  /** Cover image - image used as background cover */
  coverImage: _propTypes.default.shape({
    src: _propTypes.default.string,
    fluid: _propTypes.default.shape({}),
    fixed: _propTypes.default.shape({})
  }),

  /** Profile name - name of profile holder, placed under profile photo */
  name: _propTypes.default.string.isRequired,

  /** Job title - job title of profile holder */
  jobTitle: _propTypes.default.string,

  /** List of awards - list of awards */
  awards: _propTypes.default.arrayOf(_propTypes.default.shape({
    awardsPropTypes: _AwardsList.awardsPropTypes
  })),

  /** Location - location of the profile holder */
  location: _propTypes.default.string,

  /** skillTags - list of skills */
  skillTags: _propTypes.default.arrayOf(_propTypes.default.string),

  /** Is profile featured - makes card styling more prominent */
  featured: _propTypes.default.bool,

  /** Card Primary CTA */
  primaryCta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    variant: _propTypes.default.string
  }),

  /** Card Secondary CTA - links to button */
  secondaryCta: _propTypes.default.shape({
    label: _propTypes.default.string,
    url: _propTypes.default.string,
    variant: _propTypes.default.string
  })
};
CardProfile.defaultProps = {
  coverImage: null,
  jobTitle: null,
  awards: [],
  location: null,
  featured: false,
  skillTags: [],
  primaryCta: null,
  secondaryCta: null
};
var _default = CardProfile;
exports.default = _default;